import React, {Component} from 'react';

import strings from '../../strings';

import ReadyButton from '../../components/ReadyButton';
import AudioPlayer from '../../components/AudioPlayer';

import {nn_intro, no_intro, se_intro} from './assets';
import listen from '../../assets/listen.png';
import se_readySound from '../../assets/sounds/se/phonemeDeletion/SWFUC2-08.mp3';

class Intro extends Component {
	constructor(props) {
		super(props);

		this.state = {isShowingPractiseTests: false};

		switch (strings.getLanguage()) {
			case 'se':
				this.assets = se_intro;
				this.readySound = se_readySound;
				break;
			case 'nn':
				this.assets = nn_intro;
				this.readySound = null;
				break;
			case 'no':
			default:
				this.assets = no_intro;
				this.readySound = null;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (this.props.currentStep !== newProps.currentStep) {
			if (newProps.currentStep || newProps.currentStep === 0) {
				this.setState({
					currentStep: newProps.currentStep,
				});
			}
		}
	}

	getTaskAudio = (step) => {
		switch (step) {
			case 1:
				return this.assets.task1;
			case 2:
				return this.assets.task1a;
			case 3:
				return this.assets.task2;
			case 4:
				return this.assets.task2a;
			case 5:
				return this.assets.task3;
			case 6:
				return this.assets.task3a;
			default:
				return null;
		}
	};

	render() {
		const {currentStep} = this.props;

		let currentTaskAudio = this.getTaskAudio(currentStep);

		return (
			<>
				{currentStep === 0 && (
					<>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={this.assets.intro}
							/>
							{strings.pd_intro1}
						</p>
						<p>{strings.pd_intro2}</p>

						{<ReadyButton onReadyChange={this.props.setReady} />}
					</>
				)}
				{currentStep > 0 && currentStep < 7 && (
					<div className="WorkingMemory">
						<img className="listen-image" src={listen} alt="" />
						<p>
							<AudioPlayer
								autoplay
								inline
								playOnSourceChanged
								src={currentTaskAudio}
							/>
							{strings.pd_testInstruction}
						</p>
					</div>
				)}
				{currentStep === 7 && (
					<>
						<p>
							{this.readySound && (
								<AudioPlayer
									autoplay
									inline
									src={this.readySound}
								/>
							)}
							{strings.pd_introDone}
						</p>
						<ReadyButton onReadyChange={this.props.setReady} />
					</>
				)}
			</>
		);
	}
}

export default Intro;
